import type { StackProps } from '@chakra-ui/react';
import { HStack, VStack } from '@chakra-ui/react';

import { useIsMyAccount } from '../../useIsMyAccount';
import { Address } from './Address';
import { Nickname } from './Nickname';
import { ProfileInfo } from './ProfileInfo';

export const ProfileCard = (props: StackProps) => {
  const isMyAccount = useIsMyAccount();

  return (
    <HStack
      justifyContent="space-between"
      rounded="12px"
      borderWidth="2px"
      borderColor="text.default"
      p="12px 16px"
      bg={[
        'url(/images/profile/profile-card-bg.png) top left / 100% 100% no-repeat',
        isMyAccount
          ? 'linear-gradient(180deg, #FFFDEE 0%, #FFC700 100%)'
          : 'linear-gradient(180deg, #FFFDEE 0%, #BBD5FA 100%)',
      ].join(',')}
      {...props}
    >
      <VStack maxW="60%" alignItems="flex-start">
        <Nickname />
        <Address />
      </VStack>
      <ProfileInfo />
    </HStack>
  );
};
